import { render, staticRenderFns } from "./mg-input.vue?vue&type=template&id=5a4a0c76&scoped=true&"
import script from "./mg-input.vue?vue&type=script&lang=js&"
export * from "./mg-input.vue?vue&type=script&lang=js&"
import style0 from "./mg-input.vue?vue&type=style&index=0&id=5a4a0c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a0c76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
